import React from 'react'

function User({ name, email }) {
  const initials = name
    ? name.trim().split(/\s+/).slice(0, 2).map(w => w[0].toUpperCase()).join('')
    : '?';

  return (
    <div className='user'>
      <div style={{
        width: 34,
        height: 34,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.25)',
        border: '2px solid rgba(255,255,255,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter',
        fontWeight: 700,
        fontSize: 13,
        color: '#ffffff',
        letterSpacing: '0.5px',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      &nbsp;&nbsp;
      {name}
    </div>
  );
}

export default User
